export const bookingConfirm = 'Booking Confirmation'
export const sourceCity = 'source city'
export const sourceBranch = 'source branch'
export const senderNo = 'sender no.'
export const senderName = 'sender name'
export const senderGstn = 'sender GSTIN'
export const pickupAddress = 'pickup address'
export const destinationCity = 'dest. city'
export const destinationBranch = 'dest. branch'
export const receiver = 'receiver'
export const receiverNo = 'receiver no.'
export const receiverName = 'receiver name'
export const receiverGstn = 'receiver GSTIN'
export const deliveryAddress = 'delivery address'
export const consignmentType = 'consignment type'
export const description = 'description'
export const packMethod = 'pack method'
export const unit = 'unit'
export const weight = 'weight'
export const rate = 'rate'
export const freight = 'freight'
export const total = 'total'
export const collectionCartate = 'coll. cartage'
export const delCartage = 'Drop Cartage'
export const hamali = 'hamali'
export const opHamali = 'op. hamali'
export const valuation = 'valuation'
export const insurance = 'insurance'
export const docFee = 'doc. fee'
export const pickDropFee = 'pick+drop fee'
export const gst = 'GST'
export const totalCharges = 'total charges'
export const grossAmount = 'gross amount'
export const paymentMethod = 'method of payment'
export const bookingType = 'booking type'
export const pincode='pincode '